"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var JournalEntryLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(JournalEntryLineResource, _super);
    function JournalEntryLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JournalEntryLineResource.endpoint = '/lines/je';
    JournalEntryLineResource.MODEL_NAME = 'journalentryline';
    return JournalEntryLineResource;
}(lines_1.BaseLineResource));
exports.default = JournalEntryLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/je/lines.js
// module id = t9Wz
// module chunks = 0